const buildInvoices = responseData => {
  if (responseData?.invoices) {
    const invoicesList = [];

    responseData.invoices.forEach(invoice => {
      const {
        invoice_method_id,
        total_amount,
        invoice_method_type,
        invoice_id,
        credit_flg,
        created_at,
        invoice_items
      } = invoice;
      const formattedInvoiceItems = invoice_items.map(item => {
        const {
          member_id,
          amount,
          product_nm,
          invoice_tracking_type,
          invoice_tracking_text,
          invoice_item_id,
          description,
          invoice_tracking_id,
          group_relation_pricing_id
        } = item;

        return {
          member_id,
          amount,
          product_nm,
          invoice_tracking_type,
          invoice_tracking_text,
          invoice_item_id,
          invoice_id,
          description,
          created_at,
          invoice_tracking_id,
          group_relation_pricing_id
        };
      });

      invoicesList.push({
        childrenData: {
          componentName: "Invoice",
          createdAt: created_at,
          name: invoice_items[0].product_nm
        },
        key: "selectedData",
        type: "listItemWrapper",
        title: "",
        childrenType: "invoice",
        selectedData: {
          invoice_method_id,
          total_amount,
          invoice_method_type,
          invoice_id,
          credit_flg,
          created_at,
          invoice_items: formattedInvoiceItems
        }
      });
    });

    return invoicesList;
  }

  return [];
};

export default buildInvoices;
